/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { RewardsAndOffersContext } from '../contexts';
import { rhGeneral } from '../constants/RewardsHub';
var assets = rhGeneral.assets;
export var PxccMultiplierIcon = function (props) {
    var isBorderless = props.isBorderless, fontSizeClass = props.fontSizeClass, diameter = props.diameter;
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var perkAccrualSummary = (rewardsAndOffers || {}).perkAccrualSummary;
    var activePxccFactor = (perkAccrualSummary || {}).activePxccFactor;
    var borderWidth = isBorderless ? '' : 'sui-border-2';
    var textClass = fontSizeClass !== null && fontSizeClass !== void 0 ? fontSizeClass : 'sui-text-base';
    return (React.createElement("span", { className: "sui-relative", "data-testid": "PxccMultiplier" },
        React.createElement("span", { className: "".concat(textClass, " sui-text-inverse sui-font-w-bold sui-font-display\n        sui-rounded-full sui-border-solid sui-border-white ").concat(borderWidth, "\n        sui-flex sui-items-center sui-justify-center sui-bg-brand sui-leading-none"), style: {
                padding: '2.8px 2.8px 2px 2px',
                height: "".concat(diameter || 28, "px"),
                width: "".concat(diameter || 28, "px"),
            } },
            activePxccFactor || 1,
            "X")));
};
export var PxccMultiplierCard = function (_a) {
    var _b = _a.hideMultiplier, hideMultiplier = _b === void 0 ? false : _b;
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var perkAccrualSummary = (rewardsAndOffers || {}).perkAccrualSummary;
    var activePxccFactor = (perkAccrualSummary || {}).activePxccFactor;
    var alignmentWorkaround = { bottom: '8px' };
    var style = {
        position: 'sui-absolute sui-bottom-2 sui-right-[-8px]',
        text: 'sui-text-inverse sui-font-w-bold sui-font-display md:sui-text-3xl',
        dimensions: 'sui-w-8 sui-h-8 md:sui-w-11 md:sui-h-11',
        border: 'sui-border-solid sui-border-4 sui-rounded-full sui-border-white',
        flex: 'sui-flex sui-justify-center sui-align-center sui-flex-wrap sui-content-center',
        background: 'sui-bg-brand',
        visibility: hideMultiplier ? 'sui-invisible' : '',
    };
    return (React.createElement("div", { className: "sui-relative sui-w-[72px] sui-h-[72px] md:sui-w-[110px] md:sui-h-[110px]" },
        React.createElement("img", { src: assets.pxcc, alt: "PXCC", width: "auto", height: "auto" }),
        React.createElement("div", { className: "".concat(style.position, " ").concat(style.text, " ").concat(style.dimensions, "\n                    ").concat(style.border, " ").concat(style.flex, " ").concat(style.background, " ").concat(style.visibility), style: alignmentWorkaround },
            activePxccFactor || 1,
            "X")));
};
